var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 2.17391C28.5 1.52558 27.9744 1 27.3261 1H2.67391C2.02558 1 1.5 1.52558 1.5 2.17391V25.6522C1.5 26.3005 2.02558 26.8261 2.67391 26.8261H27.3261C27.9744 26.8261 28.5 26.3005 28.5 25.6522V2.17391Z",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9783 10.3913C24.9783 10.7155 24.7155 10.9782 24.3913 10.9782H5.60869C5.28452 10.9782 5.02173 10.7155 5.02173 10.3913V5.10868C5.02173 4.78452 5.28452 4.52173 5.60869 4.52173H24.3913C24.7155 4.52173 24.9783 4.78452 24.9783 5.10868V10.3913Z",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02173 14.5H13.2391",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02173 18.0217H13.2391",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02173 21.5435H13.2391",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7609 14.5H24.9783",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7609 18.0217H24.9783",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7609 21.5435H24.9783",
    stroke: "#373737",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.734cc4308980d9aee7580b4a0a93a3e0.svg";
export { ForwardRef as ReactComponent };